import { render, staticRenderFns } from "./SalaryReports.vue?vue&type=template&id=4c9eb7d5&scoped=true"
import script from "./SalaryReports.vue?vue&type=script&lang=js"
export * from "./SalaryReports.vue?vue&type=script&lang=js"
import style0 from "./SalaryReports.vue?vue&type=style&index=0&id=4c9eb7d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9eb7d5",
  null
  
)

export default component.exports